import Link from "next/link";

export default function Footer() {
  const currentYear = 2026;

  return (
    <footer style={{ backgroundColor: "#1F1F1F" }} className="text-white">
      {/* Main Footer */}
      <div className="max-w-container mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link href="/homepage" className="flex items-center gap-3 mb-4">
              <img
                src="/assets/images/Untitled-1772518473290.jpeg"
                alt="Kratapillar logo"
                className="h-14 w-auto object-contain"
              />
            </Link>
            <p
              className="text-sm leading-relaxed max-w-xs"
              style={{ color: "rgba(255,255,255,0.5)", fontFamily: "Inter, system-ui, sans-serif" }}
            >
              One product. Done right. Lab-verified premium kratom powder for experienced users who demand consistency.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="#"
                className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-olive transition-colors"
                aria-label="Instagram"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.5" />
                  <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5" />
                  <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
                </svg>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-olive transition-colors"
                aria-label="X / Twitter"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M4 4L20 20M20 4L4 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </a>
            </div>
          </div>

          {/* Pages */}
          <div>
            <p
              className="text-xs font-semibold uppercase tracking-widest mb-5"
              style={{ color: "rgba(255,255,255,0.35)", fontFamily: "Inter, system-ui, sans-serif" }}
            >
              Pages
            </p>
            <ul className="space-y-3">
              {[
                { label: "Shop", href: "/shop" },
                { label: "Lab Testing", href: "/lab-testing" },
                { label: "About", href: "/about" },
                { label: "FAQ", href: "/faq" },
              ]?.map((link) => (
                <li key={link?.href}>
                  <Link
                    href={link?.href}
                    className="text-sm transition-colors hover:text-white"
                    style={{ color: "rgba(255,255,255,0.55)", fontFamily: "Inter, system-ui, sans-serif" }}
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <p
              className="text-xs font-semibold uppercase tracking-widest mb-5"
              style={{ color: "rgba(255,255,255,0.35)", fontFamily: "Inter, system-ui, sans-serif" }}
            >
              Support
            </p>
            <ul className="space-y-3">
              {[
                { label: "Shipping & Returns", href: "/shipping-returns" },
                { label: "FAQ", href: "/faq" },
                { label: "Contact Us", href: "/contact" },
                { label: "Lab Results", href: "/lab-testing" },
              ]?.map((link) => (
                <li key={link?.href}>
                  <Link
                    href={link?.href}
                    className="text-sm transition-colors hover:text-white"
                    style={{ color: "rgba(255,255,255,0.55)", fontFamily: "Inter, system-ui, sans-serif" }}
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p
              className="text-xs"
              style={{ color: "rgba(255,255,255,0.35)", fontFamily: "Inter, system-ui, sans-serif" }}
            >
              © {currentYear} Kratapillar. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              {["Privacy Policy", "Terms of Service", "Disclaimer"]?.map((item) => (
                <a
                  key={item}
                  href="#"
                  className="text-xs transition-colors hover:text-white/70"
                  style={{ color: "rgba(255,255,255,0.35)", fontFamily: "Inter, system-ui, sans-serif" }}
                >
                  {item}
                </a>
              ))}
            </div>
          </div>
          <p
            className="text-xs mt-4 max-w-2xl"
            style={{ color: "rgba(255,255,255,0.25)", fontFamily: "Inter, system-ui, sans-serif" }}
          >
            * These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. For adults 21+ only. Keep out of reach of children.
          </p>
        </div>
      </div>
    </footer>
  );
}